export const version = "7.3.6";
export const major = Number("7");
export const minor = Number("3");
export const patch = Number("6");
export const prerelease = undefined;
export default version;